// Setup

/* eslint-disable wrap-iife */
/* eslint-disable complexity */
/* eslint-disable max-statements */

/* global jQuery */

class DispatchSkinSetup {

	/**
	 * Constructs the class and sets up instance variables.
	 */
	constructor() {

		this.finishEvent = 'setupfinsh';

		this.browserClass = '_browser';
		this.deviceClass = '_device';

		this.browser = null;
		this.device = null;
	}

	/**
	 * Does all the prelim setup. Fires an event to listen for when complete.
	 */
	initialize() {

		this.sniffBrowsers();
		jQuery( window ).trigger( this.finishEvent );
	}

	/**
	 * Sniff browsers and add their classes to the body
	 */
	sniffBrowsers() {

		// Get the user agent
		const userAgent = window.navigator.userAgent;

		// If the user agent contains these browser strings, add their browser class to the body and set the browser variable

		if ( userAgent.indexOf( 'Lynx' ) !== -1 ) {
			jQuery( 'body' ).addClass( this.browserClass + '--lynx' );
			this.browser = 'lynx';
		}

		else if ( userAgent.indexOf( 'Edge' ) !== -1 ) {
			jQuery( 'body' ).addClass( this.browserClass + '--edge' );
			this.browser = 'edge';
		}

		else if ( userAgent.toLowerCase().indexOf( 'chrome' ) !== -1 ) {
			jQuery( 'body' ).addClass( this.browserClass + '--chrome' );
			this.browser = 'chrome';
		}

		else if ( userAgent.toLowerCase().indexOf( 'safari' ) !== -1 ) {
			jQuery( 'body' ).addClass( this.browserClass + '--safari' );
			this.browser = 'safari';
		}

		else if (
			userAgent.indexOf( 'MSIE' ) !== -1
			|| userAgent.indexOf( 'Trident' ) !== -1
		) {
			jQuery( 'body' ).addClass( this.browserClass + '--ie' );
			this.browser = 'ie';
		}

		else if ( userAgent.indexOf( 'Gecko' ) !== -1 ) {
			jQuery( 'body' ).addClass( this.browserClass + '--gecko' );
			this.browser = 'gecko';
		}

		else if ( userAgent.indexOf( 'Opera' ) !== -1 ) {
			jQuery( 'body' ).addClass( this.browserClass + '--opera' );
			this.browser = 'opera';
		}

		else if ( userAgent.indexOf( 'Nav' ) !== -1 && userAgent.indexOf( 'Mozilla/4.' ) !== -1 ) {
			jQuery( 'body' ).addClass( this.browserClass + '--ns4' );
			this.browser = 'ns4';
		}

		else {
			jQuery( 'body' ).addClass( this.browserClass + '--unknown' );
		}

		// If the browser is Safari and there is a 'mobile' string in the UA
		if ( this.browser === 'safari' && userAgent.toLowerCase().indexOf( 'mobile' ) !== -1 ) {
			jQuery( 'body' ).addClass( this.deviceClass + '--ios' );
			this.device = 'ios';
		}
	}

}

const setup = new DispatchSkinSetup();
export default setup;




// WEBPACK FOOTER //
// ./src/js/inc/setup.js